import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["name", "id", "rows", "placeholder", "value", "disabled", "maxlength"]
const _hoisted_4 = ["type", "name", "id", "placeholder", "value", "disabled", "min", "max", "step", "maxlength", "oninput", "autocomplete"]
const _hoisted_5 = {
  key: 4,
  class: "absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"
}
const _hoisted_6 = {
  key: 2,
  class: "text-[10px] text-gray-600 mt-1"
}

import { ExclamationCircleIcon } from "@heroicons/vue/24/solid";
import { watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: {
    modelValue: {
        type: String,
        default: null,
        required: true,
    },
    helper: {
        type: String,
        default: null,
    },
    error: {
        type: String,
        default: null,
    },
    placeholder: {
        type: String,
        default: null,
    },
    autocomplete: {
        type: String,
        default: 'off',
    },
    name: {
        type: String,
        default: null,
    },
    id: {
        type: String,
        default: null,
    },
    label: {
        type: String,
        default: null,
    },
    type: {
        type: String,
        default: "text",
    },
    textarea: {
        type: Boolean,
        default: false,
    },
    textAreaRows: {
        type: Number,
        default: 10,
    },
    addOnRight: {
        type: Boolean,
        default: false,
    },
    addOnText: {
        type: String,
        default: null,
    },
    oninput: {
        type: String,
        default: null,
    },
    addOnLeft: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    min: {
        type: Number,
        default: 0,
    },
    max: {
        type: Number,
    },
    step: {
        type: Number,
        default: 1,
    },
    maxlength: {
        type: Number,
    },
    showInputLimit: {
        type: Boolean,
        default: false,
    },
    customClass: {
        type: String,
        default: "",
    },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;


const emit = __emit

watch(
    () => props.modelValue,
    (value:number) => {
        if(props.type == 'number' && props.min){
            
            if(value < props.min){
                // props.modelValue = props.min
                emit('update:modelValue', props.min)
            }
        }
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: __props.id,
          class: "block text-sm text-gray-900"
        }, _toDisplayString(__props.label), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["relative rounded-lg", [__props.addOnRight || __props.addOnLeft ? 'flex' : '', __props.label ? 'mt-1' : '']])
    }, [
      (__props.textarea)
        ? (_openBlock(), _createElementBlock("textarea", {
            key: 0,
            name: __props.name,
            id: __props.id,
            rows: __props.textAreaRows,
            class: _normalizeClass(["block w-full pr-10 text-sm rounded-lg focus:outline-none disabled:bg-gray-200", 
                    __props.error
                        ? 'text-red-900 border-red-300 placeholder-red-300 focus:border-red-500 ring-red-500'
                        : 'text-gray-900 border-gray-300 placeholder-gray-500 focus:border-gray-900 ring-gray-900'
                ]),
            placeholder: __props.placeholder,
            value: __props.modelValue,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
            disabled: __props.disabled,
            maxlength: __props.maxlength
          }, null, 42, _hoisted_3))
        : _createCommentVNode("", true),
      (__props.addOnLeft)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(["inline-flex items-center px-3 m-0 text-sm text-gray-500 border border-r-0 border-gray-300 rounded-l-md", __props.disabled ? 'bg-gray-200' : 'bg-gray-50'])
          }, _toDisplayString(__props.addOnText), 3))
        : _createCommentVNode("", true),
      (!__props.textarea)
        ? (_openBlock(), _createElementBlock("input", {
            key: 2,
            type: __props.type,
            name: __props.name,
            id: __props.id,
            class: _normalizeClass(["block w-full text-sm rounded-lg h-11 disabled:bg-gray-200 focus:outline-none", [
                    __props.customClass,
                    __props.error ? __props.addOnLeft ? 'rounded-none rounded-r-lg' : '' : 'rounded-lg',
                    __props.error ? __props.addOnRight ? 'rounded-none rounded-l-lg' : '' : 'rounded-lg',
                    __props.error 
                        ? 'text-red-900 border-red-300 placeholder-red-300 focus:border-red-500 ring-red-500'
                        : __props.addOnLeft
                        ? 'text-gray-800 border-gray-300 placeholder-gray-500 flex-1 min-w-0 rounded-none rounded-r-lg focus:border-gray-900 ring-gray-900'
                        : __props.addOnRight
                        ? 'text-gray-900 border-gray-300 placeholder-gray-500 flex-1 min-w-0 rounded-none rounded-l-lg focus:border-gray-900 ring-gray-900'
                        : 'text-gray-900 border-gray-300 placeholder-gray-500 focus:border-gray-900 ring-gray-900'
                ]]),
            placeholder: __props.placeholder,
            value: __props.modelValue,
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
            disabled: __props.disabled,
            min: __props.min,
            max: __props.max,
            step: __props.step,
            maxlength: __props.maxlength,
            oninput: __props.oninput,
            autocomplete: __props.autocomplete
          }, null, 42, _hoisted_4))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "password"),
      (__props.addOnRight)
        ? (_openBlock(), _createElementBlock("span", {
            key: 3,
            class: _normalizeClass(["inline-flex items-center px-3 m-0 text-sm text-gray-500 border border-l-0 border-gray-300 rounded-r-md", __props.disabled ? 'bg-gray-200' : 'bg-gray-50'])
          }, _toDisplayString(__props.addOnText), 3))
        : _createCommentVNode("", true),
      (__props.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_unref(ExclamationCircleIcon), {
              class: "w-5 h-5 text-red-500",
              "aria-hidden": "true"
            })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (__props.showInputLimit)
      ? (_openBlock(), _createElementBlock("small", {
          key: 1,
          class: _normalizeClass(["block mt-1 text-right", [
                __props.modelValue.length >= __props.maxlength
                    ? 'text-red-600'
                    : 'text-gray-400',
            ]])
        }, _toDisplayString(__props.modelValue.length) + "/" + _toDisplayString(__props.maxlength), 3))
      : _createCommentVNode("", true),
    (__props.helper)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.helper), 1))
      : _createCommentVNode("", true),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", {
          key: 3,
          class: _normalizeClass(["text-[10px] mt-1", __props.error ? 'text-red-600' : 'text-gray-800']),
          id: "email-error"
        }, _toDisplayString(__props.error), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})